module.exports = __webpack_public_path__ + "static/Businessman Copy-3c3adfc89fbeb26db339609511378794.png";